export const StepType= Object.freeze({ LLAMADA_CONTACTO: 1, LLAMADA_AUTORIDADES: 2, CORREO_CONTACTO: 3, CORREO_OTRO: 4 });
